<template>
    <div class="dropdown is-up is-hoverable timezones">
        <div class="dropdown-trigger">
            <button class="button">
                <span>{{timezone && timezone.description}}</span>
                <span class="icon is-small">
                    <i class="fas fa-angle-down" aria-hidden="true"></i>
                </span>
            </button>
        </div>
        <div class="dropdown-menu" id="dropdown-menu4" role="menu">
            <div class="dropdown-content">
                <a v-for="tz in timezones" :key="tz.id" class="dropdown-item" @click="timezone=tz">
                    <span>{{tz.description}}</span>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';

export default {
    name: 'basement-timezones',
    computed: {
        timezones() {
            return Vue.state.timezones.get();
        },
        timezone: {
            get() {
                return Vue.state.currentTimezone.get();
            },
            set(val) {
                Vue.state.currentTimezone.set(val);
            }
        }
    }
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/common/basement/timezones.vue